import { useCallback } from "react";
import { useSearchParams } from "react-router";

interface UseUrlPaginationProps {
    pageSize?: number;
    defaultPage?: number;
}

export function useUrlPagination({ pageSize = 10, defaultPage = 0 }: UseUrlPaginationProps = {}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const currentPage = parseInt(searchParams.get("page") || String(defaultPage), 10);

    const setPage = useCallback(
        (page: number) => {
            setSearchParams((prev) => {
                const newParams = new URLSearchParams(prev);
                if (page === defaultPage) {
                    newParams.delete("page");
                } else {
                    newParams.set("page", String(page));
                }
                return newParams;
            });
        },
        [setSearchParams, defaultPage],
    );

    const resetPage = useCallback(() => {
        setPage(defaultPage);
    }, [setPage, defaultPage]);

    return {
        currentPage,
        pageSize,
        setPage,
        resetPage,
    };
}
